import { render } from "./EditMarchand.vue?vue&type=template&id=0516090b&ts=true"
import script from "./EditMarchand.vue?vue&type=script&lang=ts"
export * from "./EditMarchand.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__